import { useDispatch } from 'react-redux';
import { Link } from 'foundations-components/transitional/components/Link';
import { Button } from 'foundations-components/transitional/components/Button';
import { TableHoverContent } from 'foundations-components/transitional/components/Table';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { tagArticlesWithTerm } from '../../../actions/TagsActions';
import UsageTracker from '../../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SearchTermCellContent = ({
  searchTermUrl,
  value,
  valueLabels,
  usageTrackerObj
}) => {
  const dispatch = useDispatch();
  const onTagArticlesClick = () => {
    dispatch(tagArticlesWithTerm(value));
    UsageTracker.track('kbInsightsInteraction', usageTrackerObj);
  };
  return /*#__PURE__*/_jsxs("td", {
    style: {
      height: '100%',
      display: 'flex',
      alignItems: 'center'
    },
    children: [/*#__PURE__*/_jsx("span", {
      children: searchTermUrl ? /*#__PURE__*/_jsx(Link, {
        external: true,
        href: searchTermUrl,
        truncate: true,
        children: valueLabels.first()
      }) : valueLabels.first()
    }), /*#__PURE__*/_jsx(TableHoverContent, {
      shrinkOnHide: false,
      children: /*#__PURE__*/_jsx(Button, {
        use: "tertiary-light",
        size: "extra-small",
        onClick: onTagArticlesClick,
        marginInlineStart: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.insights.dashboard.articleTagging.tagArticlesButton"
        })
      })
    })]
  });
};
export default SearchTermCellContent;